import { FormControl } from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { FormGroup } from '../components/FormGroup'
import { FormLabel } from '../components/FormLabel'
import { InputGroup } from '../components/InputGroup'
import { PhoneInputGroup } from '../components/PhoneInputGroup'
import { useNameof } from '../hooks/useNameof'

const InsureeContact = ({ personPrefix, isDisabled = false, emailRequired = false, mobileRequired = false }:
{ personPrefix: string, isDisabled?: boolean, emailRequired?: boolean, mobileRequired?: boolean }) => {
  const nameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, getFieldState } = useFormContext()

  const { error: errorMobilePhone } = getFieldState(nameof(x => x.mobilePhone))
  const { error: errorPhone } = getFieldState(nameof(x => x.phone))
  const { error: errorEmail } = getFieldState(nameof(x => x.email))

  return (
    <FormGroup>
      <FormControl isInvalid={!!errorMobilePhone?.message} isRequired={mobileRequired}>
        <FormLabel>Mobilní telefon</FormLabel>

        <PhoneInputGroup
          select={{ ...register(nameof(x => x.mobilePhonePrefix)), isDisabled: isDisabled }}
          input={{ ...register(nameof(x => x.mobilePhone)), isDisabled: isDisabled }}
          errors={errorMobilePhone} />
      </FormControl>

      <FormControl isInvalid={!!errorPhone?.message}>
        <FormLabel optional>Pevná linka</FormLabel>

        <PhoneInputGroup input={{ ...register(nameof(x => x.phone)), isDisabled: isDisabled }} errors={errorPhone} />
      </FormControl>

      <FormControl isInvalid={!!errorEmail?.message} isRequired={emailRequired}>
        <FormLabel>E-mail</FormLabel>

        <InputGroup type="email" {...register(nameof(x => x.email))} isDisabled={isDisabled} errors={errorEmail} />
      </FormControl>
    </FormGroup>
  )
}

export default InsureeContact